import { Difficulty } from "shared/games/Difficulty";
import { Game } from "shared/games/types/Game";

export const difficultyConfig: {
  [difficutly in Difficulty]: {
    q: number;
    safeAreaInOctaves: number;
    gain: (type: Game) => number;
  };
} = {
  easy: {
    q: 0.3333,
    safeAreaInOctaves: 3,
    gain: (type) => {
      if (type === Game.freq_finder_boost) {
        return 15;
      }

      if (type === Game.freq_finder_cut) {
        return -15;
      }

      return 0;
    },
  },
  medium: {
    q: 0.3333,
    safeAreaInOctaves: 2,
    gain: (type) => {
      if (type === Game.freq_finder_boost) {
        return 8;
      }

      if (type === Game.freq_finder_cut) {
        return -8;
      }

      return 0;
    },
  },
  hard: {
    q: 0.3333,
    safeAreaInOctaves: 1,
    gain: (type) => {
      if (type === Game.freq_finder_boost) {
        return 3;
      }

      if (type === Game.freq_finder_cut) {
        return -3;
      }

      return 0;
    },
  },
};

export const freqRange = {
  min: 15,
  max: 25000,
};
